<div *ngFor="let Library of AllRoles" class="Content-title-Role">
  <!--&================= TITLE COMPONENT =================&-->
  <ng-container *ngIf="UserService.UserRoleGeneralIn(Library.Roles)">
    <div class="title-components">
      <h1>Roles {{ Library.Title }}</h1>
    </div>

    <!--&================= CONTAINER CARD OPTION REPORT =================&-->
    <div class="Content-Tasks">
      <ng-container *ngFor="let Library_Role of Library.Library">
        <div class="Card-Task">
          <div class="Content-Card">
            <div class="Card-Notification">
              <div class="notifications button-square">
                <i class="fa-solid fa-file-shield"></i>
              </div>
            </div>
            <div class="Body-Card">
              <div class="Title-Card">
                <h2>{{ Library_Role.Library }}</h2>
              </div>
              <div class="Subtitle-Card">
                {{ GetGreeting() }}, {{ NameUser() }},
                {{ Library_Role.Description }}
              </div>
            </div>
          </div>
          <div class="Btn-See-Task">
            <button
              [disabled]="!UserService.UserRoleGeneralIn(Library_Role.Roles)"
              [class.Is-Disabled]="
                !UserService.UserRoleGeneralIn(Library_Role.Roles)
              "
              routerLink="{{ Library_Role.RouteLink }}"
              class="Btn-Task btn-icon-text-left"
            >
              <span class="text">{{
                UserService.UserRoleGeneralIn(Library_Role.Roles)
                  ? "Ver Rol"
                  : "Sin Permisos"
              }}</span
              ><i class="fa-solid fa-shield-halved"></i>
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngFor="let item of Library.NotRelated">
        <div></div>
      </ng-container>
      
    </div>
  </ng-container>
</div>
